import { badgeHistoryActions } from '../../../../backend/features/badges/shared';
import { useBadgingTranslation } from '../../../../ui/hooks';
export function useBadgeHistoryActionValueProvider() {
    const { t } = useBadgingTranslation();
    return {
        type: 'badgeHistoryActions',
        label: 'Badge History Actions',
        getValues: () => Promise.resolve(badgeHistoryActions.map((action) => ({
            value: action,
            label: t(`badges.badgeDetails.badgeHistoryTable.filters.actions.${action}`),
        }))),
    };
}
